import { Star, ExternalLink, Phone } from "lucide-react";
import { useQuote } from "../lib/quoteContext";
import { SITE } from "../lib/site";

const AVATARS = [
  "https://i.pravatar.cc/100?img=47",
  "https://i.pravatar.cc/100?img=32",
  "https://i.pravatar.cc/100?img=68",
];

export default function Hero() {
  const { openQuote } = useQuote();
  return (
    <section
      id="top"
      className="relative w-full overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, #DCEBFB 0%, #DCEBFB 70%, #E8F1FB 100%)",
        minHeight: "100vh",
      }}
      data-testid="hero-section"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-10 pt-28 sm:pt-32 lg:pt-36 pb-12 lg:pb-16 min-h-screen flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 w-full items-center">
          {/* LEFT */}
          <div className="lg:col-span-7 relative z-10 fade-up">
            {/* Trust avatars */}
            <div
              className="flex items-center gap-3 mb-6 sm:mb-8"
              data-testid="hero-trust"
            >
              <div className="flex -space-x-2">
                {AVATARS.map((a, i) => (
                  <img
                    key={i}
                    src={a}
                    alt="Customer"
                    className="w-9 h-9 rounded-full border-2 border-white object-cover"
                  />
                ))}
                <div className="px-2.5 min-w-[36px] h-9 rounded-full bg-[#183B87] text-white text-[12px] font-semibold flex items-center justify-center border-2 border-white">
                  +32
                </div>
              </div>
              <p className="text-[13px] sm:text-[14px] text-[#1A2B4A]">
                Rated <span className="font-semibold">4.9/5</span> by 500+
                Homeowners
              </p>
            </div>

            <h1 className="font-serif text-[34px] leading-[1.1] sm:text-[42px] lg:text-[50px] xl:text-[54px] text-[#173B86] tracking-[-0.01em] max-w-[760px]" style={{ fontWeight: 600 }}>
              All Cleaning Services. Simple Booking. Get 20% Off on Our Website.
            </h1>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-8">
              <button
                onClick={() => openQuote()}
                className="tc-btn-primary"
                data-testid="hero-cta-quote"
              >
                Request a Quote
              </button>
              <a
                href="https://wa.me/48572410075"
                target="_blank"
                rel="noopener noreferrer"
                className="tc-btn-outline inline-flex items-center justify-center gap-2"
                data-testid="hero-cta-whatsapp"
              >
                <Phone className="w-4 h-4" /> Call me on WhatsApp
              </a>
            </div>

            {/* Profile card */}
            <div
              className="mt-10 inline-flex items-center gap-4 bg-white rounded-2xl shadow-md pl-3 pr-5 py-3 sm:py-3 max-w-full"
              data-testid="hero-profile-card"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/9cfvmucv_image.png"
                alt="Tina"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="flex flex-col">
                <div className="flex items-center gap-1.5">
                  <Star className="w-3.5 h-3.5 fill-[#F5B700] text-[#F5B700]" />
                  <span className="text-[14px] font-semibold text-[#1A2B4A]">
                    Hi! I am Tina!
                  </span>
                </div>
                <span className="text-[11.5px] text-[#5b6a85]">
                  Owner of Pure Wave by Tina LLC
                </span>
              </div>
              <div className="block w-px h-9 bg-[#e8ecf3] mx-1" />
              <a
                href={SITE.thumbtack}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[12.5px] text-[#173B86] font-medium hover:underline whitespace-nowrap"
                data-testid="hero-mytech-link"
              >
                My Thumbtack <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>

          {/* RIGHT — illustration */}
          <div className="lg:col-span-5 relative h-[300px] sm:h-[400px] lg:h-[560px]">
            <img
              src={SITE.hero.illustration}
              alt="Cleaner illustration"
              className="absolute inset-0 w-full h-full object-contain pointer-events-none"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
